import {StepLabel, Stepper, styled} from '@mui/material';

const StyledStepper = styled(Stepper)`
	overflow-x: auto;

	.MuiStepConnector-horizontal {
		max-width: 24px;
	}

	/* width */
	::-webkit-scrollbar {
		height: 4px;
	}

	/* Track */
	::-webkit-scrollbar-track {
		background: transparent;
		border-radius: 4px;
	}

	/* Handle */
	::-webkit-scrollbar-thumb {
		border-radius: 4px;
		background: ${({theme}) => theme.palette.action.disabled};
	}

	/* Handle on hover */
	::-webkit-scrollbar-thumb:hover {
		background: ${({theme}) => theme.palette.action.disabled};
	}
`;

const StyledStepLabel = styled(StepLabel)`
	& .MuiStepLabel-iconContainer {
		padding-right: 0px;
		margin-right: 8px;
		border: 1px solid transparent;
		border-radius: 50%;
		position: relative;

		&.Mui-disabled {
			border-color: white;
		}

		&.Mui-completed::before {
			content: '';
			width: 20px;
			height: 20px;
			background-color: white;
			position: absolute;
			border-radius: 50%;
			top: 2px;
			left: 2px;
		}
	}

	& .MuiStepIcon-root {
		fill: ${({theme}) => theme.palette.primary.main};
		z-index: 1;
	}

	& .MuiStepIcon-root.Mui-active {
		fill: white;

		& .MuiStepIcon-text {
			fill: ${({theme}) => theme.palette.primary.main};
		}
	}

	& .MuiStepIcon-root.Mui-completed {
		fill: ${({theme}) => theme.palette.success.main};
	}

	& .MuiStepIcon-text {
		font-size: 0.875rem;
	}

	& .MuiStepLabel-label {
		color: white;
		white-space: nowrap;
	}

	& .MuiStepLabel-label.Mui-completed {
		color: ${({theme}) => theme.palette.other.stepperLabelDisabled};
	}
`;

export {StyledStepper, StyledStepLabel};
